import DashboardContainer from './main-dashboard/Dashboard';

export default function Dashboard() {
    return (
        <div className="bg-gray-50">
            <main className="max-w-7xl">
                   <DashboardContainer/>
            </main>
        </div>
    )
}
